module.exports = __webpack_public_path__ + "static/media/logo-horizontal-fundo-azul.8b1c51fe.png";